import { TEXT_BODY, TEXT_MUTED, RADIUS } from '../../lib/medievalTheme';
import { getClass } from '../../utils/arena/classes';
import { OMENS, rewardLabel } from '../../utils/arena/oracle';
import { t } from '../../localization/t';

const ACCENT = getClass('oracle').accent;
const GOOD = '#8fd3a4';
const BAD = '#e89090';

function predictionLine(p) {
  if (p.correct) return { color: GOOD, text: t('Your prediction held. Rewards doubled.') };
  if (p.spared) return { color: TEXT_BODY, text: t('Your prediction failed, but the cards were kind. No penalty.') };
  return { color: BAD, text: t('Your prediction failed. Rewards halved.') };
}

// The settled reading on the match result screen: how the prediction
// fared, whether the kept omen came true, and the Foresight now banked.
export default function OracleResult({ oracle }) {
  const { prediction, omen, foresight, maxForesight, foresightDelta, cards = [], packs = [] } = oracle;
  const def = omen ? OMENS[omen.id] : null;
  if (!prediction && !def) return null;
  const line = prediction ? predictionLine(prediction) : null;
  return (
    <div
      className="match-result-plate flex flex-col mb-3 rounded-lg"
      style={{ padding: '0.5cqw 0.75cqw', gap: '0.375cqw', fontSize: '0.75cqw', lineHeight: 1.35 }}
      data-testid="oracle-result"
    >
      <div className="flex items-center justify-between">
        <span className="arena-heading" style={{ color: ACCENT, fontSize: '0.875cqw' }}>{t('The reading')}</span>
        <span className="tabular-nums" style={{ color: TEXT_MUTED }}>
          {t('Foresight {n} / {max}', { n: foresight, max: maxForesight })}
          {foresightDelta > 0 ? <span style={{ color: GOOD }}> +{foresightDelta}</span> : null}
        </span>
      </div>
      {line ? (
        <div style={{ color: line.color }}>
          {line.text}
          {prediction.bonusCoins > 0 ? ` ${t('Mind over Matter: +{n} Gold and Arcana.', { n: prediction.bonusCoins })}` : ''}
        </div>
      ) : null}
      {def ? (
        <div className="flex items-center" style={{ gap: '0.625cqw' }}>
          <img
            src={def.art} alt="" draggable={false}
            style={{ width: '2.25cqw', aspectRatio: '3 / 5', objectFit: 'cover', borderRadius: RADIUS.xs, filter: omen.completed ? 'none' : 'grayscale(0.8) brightness(0.7)' }}
          />
          <div className="flex flex-col">
            <span className="arena-heading" style={{ color: omen.completed ? GOOD : TEXT_MUTED, fontSize: '0.8125cqw' }}>
              {omen.completed ? t('{omen} fulfilled', { omen: t(def.title) }) : t('{omen} unfulfilled', { omen: t(def.title) })}
            </span>
            <span style={{ color: omen.completed ? TEXT_BODY : TEXT_MUTED }}>
              {omen.completed
                ? rewardLabel(omen.reward)
                : def.insight ? t('Damage taken: {n}', { n: omen.value }) : t('{value} of {target}', { value: omen.value, target: omen.target })}
            </span>
          </div>
        </div>
      ) : null}
      {packs.length ? <div style={{ color: TEXT_MUTED }}>{t('Packs wait for you in the Store.')}</div> : null}
      {cards.length ? <div style={{ color: TEXT_MUTED }}>{cards.length === 1 ? t('1 card was written into your collection.') : t('{n} cards were written into your collection.', { n: cards.length })}</div> : null}
    </div>
  );
}
